import useBodyScrollLock from '../hooks/useBodyScrollLock';
import React, { useContext, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useHistory } from 'react-router-dom';
import DarkModeContext from './DarkModeContext';

function AuthRequiredModal({ show, onClose, title = "Autenticación Requerida", message = "Debes iniciar sesión para acceder a esta funcionalidad", resumeAction = null }) {
    const history = useHistory();
    const { darkMode } = useContext(DarkModeContext);

    // Prevenir scroll del fondo cuando el modal está abierto
    useBodyScrollLock(show);

    const handleLogin = () => {
        onClose();
        // resumeAction viaja como location.state (no query string) para que
        // Login.jsx pueda retomar la acción original (ej. abrir el chat con
        // la modelo que se quería contactar) en vez de mandar al usuario a
        // la home genérica de su rol después de loguearse.
        history.push('/login', resumeAction ? { resumeAction } : undefined);
    };

    const handleCancel = () => {
        onClose();
    };

    if (!show) return null;

    // Portal a <body>: se abre desde otros modales (perfil, chat) y, dentro de
    // ellos, su z-index no podía pasar por encima del modal padre.
    return createPortal(
        <div className="fixed z-confirm inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="flex items-end justify-center min-h-dvh pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
                <span className="hidden sm:inline-block sm:align-middle sm:h-dvh" aria-hidden="true">&#8203;</span>
                <div className="inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                    <div className={`px-4 pt-5 pb-4 sm:p-6 sm:pb-4 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
                        <div className="sm:flex sm:items-start">
                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                <h3 className={`text-lg leading-6 font-medium ${darkMode ? 'text-white' : 'text-gray-900'}`} id="modal-title">
                                    {title}
                                </h3>
                                <div className="mt-2">
                                    <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-500'}`}>
                                        {message}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse ${darkMode ? 'bg-gray-700' : 'bg-gray-50'}`}>
                        <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-full border border-transparent shadow-sm px-4 py-2 bg-rose-600 text-base font-medium text-white hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={handleLogin}
                        >
                            Iniciar Sesión
                        </button>
                        <button
                            type="button"
                            className={`mt-3 w-full inline-flex justify-center rounded-full border ${darkMode ? 'border-gray-600' : 'border-gray-200'} shadow-sm px-4 py-2 ${darkMode ? 'bg-gray-700 text-white' : 'bg-white text-gray-700'} text-base font-medium ${darkMode ? 'hover:bg-gray-500' : 'hover:bg-gray-50'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm`}
                            onClick={handleCancel}
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default AuthRequiredModal;
